// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chip-group[data-v-cb9f794c]{display:flex;gap:.1rem;max-width:300px}.spacer-2[data-v-cb9f794c]{margin-top:.5rem}.genre[data-v-cb9f794c]{display:flex;justify-content:center;align-items:center}p[data-v-cb9f794c]{font-size:small;font-weight:700}", ""]);
// Exports
module.exports = exports;
